import { h, Fragment } from 'preact'

import iconStyle from '@styles/icon.module.css'

import useI18NText from '../hooks/useI18NText'

import Modal from './components/Modal'
import ItemCookie from './components/ItemCookie'
import SwitchBtn from './components/SwitchBtn'

import style from './style.module.css'

Modal.setAppElement('body')

const modalStyle = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    zIndex: 100001,
  },
  content: {
    position: 'absolute',
    background: 'transparent',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    marginTop: '15px',
    transform: 'translate(-50%, -50%)',
    overflow: 'hidden',
    borderRadius: '6px',
    border: 'none',
    width: '85%',
    maxWidth: '440px',
    height: 'auto',
    padding: '0',
    boxShadow: 'none',
  },
}

export default function Template({
  isOpenCookieSetting,
  isAcceptTargeting,
  isAcceptPerformance,
  isAcceptAdvertising,
  onToggleTargeting,
  onTogglePerformance,
  onToggleAdvertising,
  isShowDetailSanookWebsiteCookie,
  isShowDetailPerformanceCookie,
  isShowDetailTargetingCookie,
  isShowDetailAdvertisingCookie,
  onToggleDetailSanookWebsiteCookie,
  onToggleDetailPerformanceCookie,
  onToggleDetailTargetingCookie,
  onToggleDetailAdvertisingCookie,
  onCloseModal,
  onClickOutsideModal,
  onAcceptAll,
  onSave,
}) {
  const text = useI18NText('cookieSetting')

  return (
    <Fragment>
      <Modal
        isOpen={isOpenCookieSetting}
        onRequestClose={onClickOutsideModal}
        style={modalStyle}>
        <button onClick={onCloseModal} className={style.closeBtn}>
          <i
            className={`${iconStyle['sn-icon']} ${iconStyle['sn-icon--cancel-s']}`}
          />
        </button>
        <div className={style.CookieSetting}>
          <div className={style.CookieSettingHeader}>
            <h2 className={style.CookieSettingHeaderTitle}>{text.title}</h2>
            <p className={style.CookieSettingHeaderParagraph}>
              {text.subTitle}
            </p>
          </div>
          <div className={style.CookieSettingBg}>
            <div className={style.CookieSettingBody}>
              <div className={style.modalSetting}>
                <ItemCookie
                  onToggle={onToggleDetailSanookWebsiteCookie}
                  isShow={isShowDetailSanookWebsiteCookie}
                  title={text?.cookies?.necessary?.title}
                  subTitle={text?.cookies?.necessary?.subTitle}
                  detail={text?.cookies?.necessary?.description}>
                  <SwitchBtn disabled isAccept={true} />
                </ItemCookie>
                <ItemCookie
                  onToggle={onToggleDetailPerformanceCookie}
                  isShow={isShowDetailPerformanceCookie}
                  title={text?.cookies?.performance?.title}
                  subTitle={text?.cookies?.performance?.subTitle}
                  detail={text?.cookies?.performance?.description}>
                  <SwitchBtn
                    onClick={onTogglePerformance}
                    isAccept={isAcceptPerformance}
                  />
                </ItemCookie>
                <ItemCookie
                  onToggle={onToggleDetailTargetingCookie}
                  isShow={isShowDetailTargetingCookie}
                  title={text?.cookies?.targeting?.title}
                  subTitle={text?.cookies?.targeting?.subTitle}
                  detail={text?.cookies?.targeting?.description}>
                  <SwitchBtn
                    onClick={onToggleTargeting}
                    isAccept={isAcceptTargeting}
                  />
                </ItemCookie>
                <ItemCookie
                  onToggle={onToggleDetailAdvertisingCookie}
                  isShow={isShowDetailAdvertisingCookie}
                  title={text?.cookies?.advertising?.title}
                  subTitle={text?.cookies?.advertising?.subTitle}
                  detail={text?.cookies?.advertising?.description}>
                  <SwitchBtn
                    onClick={onToggleAdvertising}
                    isAccept={isAcceptAdvertising}
                  />
                </ItemCookie>
              </div>
              <div className={style.desc}>
                <div className={style.descScroll}>
                  <p className={style.descParagraph}>{text?.description}</p>
                </div>
              </div>
            </div>
            <div className={style.CookieSettingFooter}>
              <button
                onClick={onAcceptAll}
                className={`${style.CookieSettingFooterButton} ${style.acceptBtn}`}>
                <span>{text?.acceptAllBtn}</span>
              </button>
              <button
                onClick={onSave}
                className={`${style.CookieSettingFooterButton} ${style.saveBtn}`}>
                <span>{text?.saveBtn}</span>
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </Fragment>
  )
}
